
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class QueueService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/queues',query);
    }

    listCalloutQueues(query?: any) {
        return this.get('/calloutQueues', query);
    }

    create(body: any) {
        return this.post('/queue',body);
    }

    find(id) {
        return this.get('/queue/'+id);
    }

    update(id, body) {
        return this.put('/queue/'+id, body);
    }

    allQueue(query?: any) {
        return this.get('/all-queue', query);
    }

    _delete(id) {
        return this.delete('/queue/'+id);
    }

    allQueueManager(query?: any) {
        return this.get('/all-queue-manager', query);
    }

    allParam(query?: any) {
        return this.get('/all-param', query);
    }

    addParam(queue_id, body) {
        return this.post('/add-param/'+queue_id, body);
    }

    addAgent(queue_id, body) {
        return this.post('/add-agent/'+queue_id, body);
    }

    deleteParam(queue_id, param_id) {
        return this.delete('/del-param/'+queue_id+'/'+param_id);
    }
    deleteAgent(queue_id, agent_id) {
        return this.delete('/del-agent/'+queue_id+'/'+agent_id);
    }

    agentInQueue(queue_id) {
        return this.get('/agent-in-queue/'+queue_id);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Queue.service.ts